module.exports = __webpack_public_path__ + "static/Classroom-Activity-1-2-Body-Talk-ES-99ca9e6c7bea2f391e6e16888567039d.pdf";